"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useDrawerHeaderTitle_unstable", {
    enumerable: true,
    get: function() {
        return useDrawerHeaderTitle_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactutilities = require("@fluentui/react-utilities");
const _reactdialog = require("@fluentui/react-dialog");
/**
 * @internal
 * Create the shorthand for the heading element.
 * @param props - props from this instance of DrawerHeaderTitle
 */ const useHeadingProps = ({ children, heading })=>{
    const id = (0, _reactdialog.useDialogContext_unstable)((ctx)=>ctx.dialogTitleId);
    return _reactutilities.slot.optional(heading, {
        defaultProps: {
            id,
            children
        },
        renderByDefault: true,
        elementType: 'h2'
    });
};
const useDrawerHeaderTitle_unstable = (props, ref)=>{
    const headingProps = useHeadingProps(props);
    return {
        components: {
            root: 'div',
            heading: 'h2',
            action: 'div'
        },
        root: _reactutilities.slot.always((0, _reactutilities.getIntrinsicElementProps)('div', {
            ref,
            ...props
        }), {
            elementType: 'div'
        }),
        heading: headingProps,
        action: _reactutilities.slot.optional(props.action, {
            elementType: 'div'
        })
    };
};
